module.exports = __webpack_public_path__ + "static/media/empty.bb072485.png";